namespace SPA {

	export namespace Marketing {

		export class Modal {
			private static shown: boolean = false;

			private modal: ui.dialog.Modal;

			public constructor()
			{
				this.modal = this.ModalHtml();

				this.modal.Root().on('hidden.bs.modal', () => {
					Modal.shown = false;
				});
			}

			public Show()
			{
				if (Modal.shown)
				{
					return;
				}

				Modal.shown = true;
				this.modal.Show();
			}

			private ModalHtml()
			{
				const uiModal = new ui.dialog.Modal({
					size: 'lg',
					noCloseBtn: false,
					head: [$('<h3>Marketing-Assistent</h3>')],
					body: [
						$(`<div style='font-size:16px'></a><p>Auf Basis der Bodenrichtwertkarte mit Zonenbildung, bildet GSD eine Lagebewertung ab.<br>
Diese Bewertung identifiziert für Sie Lage-Informationen wie:</p>
<ul>
    <li>Mischgebiete</li>
    <li>Verschiedene Wohngebiete</li>
    <li>Geschoßwohnungsbau</li>
    <li>Industriegebiete</li>
    <li>Kerngebiete</li>
    <li>Etc.</li>
</ul>
<p>Auf Basis dieser Informationen haben Sie z.B. die Möglichkeit Mailings entsprechend Ihrer Zielgruppe
zu qualifizieren, dadurch Kosten zu sparen und zielgerichteter zu werben.</p>

<p>Auch Informationen von Finanzierungsaktivitäten in den einzelnen Zone ist möglich.<br>
Kontaktieren Sie uns für weitere Informationen.<br>&nbsp;</p>

<a class='btn btn-primary' href='mailto:service@gsd-web.de'>E-Mail an service@gsd-web.de schreiben</a></div>`)
					]
				});

				return uiModal;
			}
		}
	}
}
